import * as React from "react";

import ApplicationRouter from 'components/general/ApplicationRouter';
import { Provider } from 'react-redux'
import { store } from 'state-management/store'
import { ViewportProvider } from 'components/general/useViewPort'
import { useLocation } from "react-router-dom";
import NotAvailable from 'components/common/NotAvailable';
import Loader from 'components/general/Loader';
import { getLanguages, getRoutes } from 'data/Querys';
import { useQuery, useQueries } from 'react-query';

export default function App() {

  //Remove only for logs 
  //window.store = store

  const Layout = ({ children }) => {
    let location = useLocation();
    let pathVars = location.pathname.split('/')
    import(`styles/${pathVars[1]}/variables.scss`);


    if (pathVars[1] === ("EG2023")) {
      document.title = "European Games 2023";
      var link = document.querySelector("link[rel~='icon']");
      link.href = process.env.PUBLIC_URL + '/EG2023.ico';

    } else {
      document.title = "Mirs App";
      var link = document.querySelector("link[rel~='icon']");
      link.href = process.env.PUBLIC_URL + '/favicon.ico';
    }

    return (
      <div id='mirs-app'>
        {children}
      </div>
    );
  };

  return (

    <Layout>
      <Provider store={store}>
        <ViewportProvider>
          <DataAndRouter />
        </ViewportProvider>
      </Provider>
    </Layout>
  );
}

function DataAndRouter() {
  // load languages and Routes
  const { data: dataLanguages, isError: isErrorLanguages, isLoading: isLoadingLanguages } = useQuery(
    {
      queryKey: ['CC_Languages'],
      queryFn: getLanguages,
      refetchInterval: 0,
      staleTime: Infinity,
      refetchIntervalInBackground: true,
      retry: false,
      suspense: false,

    }
  )

  //  if (isErrorLanguages) { return <NotAvailable />; }
  //  if (isLoadingLanguages) { return <Loader />; }


  let language = dataLanguages?.languages[0].lang

  //LOAD INITIAL DATA
  let queryArray = [];
  //dataLanguages?.languages?.forEach(item => {

  ['ENG', 'FRA', 'CHI', 'POL'].forEach(item => {
    //let router_language = item.lang;
    let router_language = item;
    queryArray.push({
      queryKey: ['routerPaths', { router_language }],
      queryFn: getRoutes,
      refetchInterval: 0,
      staleTime: Infinity,
      //refetchIntervalInBackground: false,
      retry: false,
      //suspense: false,
      enabled: !!language
    })
  });


  const results = useQueries(queryArray);
  const isLoading = isLoadingLanguages || results.some(result => result.isLoading)
  const isError = isErrorLanguages || results.some(result => result.isError)


  //console.log("isLoading: " + results.some(result => result.isLoading))
  //console.log("fetchStatus : " + results.some(result => result.fetchStatus))
  //console.log("Enabled: " + !!language)


  if (isError) { return <NotAvailable />; }
  if (isLoading) { return <Loader />; }


  //console.log("Languages loaded")
  return (
    < ApplicationRouter />
  )

}
